// Тексты, которыми даётся согласие. SMY-153 · «Новая регистрация» Э1
//
// Живут в ядре по той же причине, что текст предложения завести пароль
// (`PASSWORD_OFFER_TEXT`): один абзац на четыре места — первый экран и профиль
// на двух платформах. Копии расходятся не сразу, расходится та, которую
// правят, — и человек получает два разных обещания об одном и том же.
//
// Здесь цена расхождения выше обычной. Это не подпись к кнопке, а СОДЕРЖАНИЕ
// ЮРИДИЧЕСКОГО ДЕЙСТВИЯ: то, чем мы доказываем полученное согласие. Разбор —
// docs/legal/guest-account.md.

/**
 * Согласие продолжением работы. Первый экран обеих платформ и профиль.
 *
 * ⚠️ «ПРОДОЛЖАЯ», А НЕ «НАЖИМАЯ КНОПКУ». Чекбокса на регистрации больше нет —
 * регистрации на входе нет вовсе, аккаунт заводит первый запуск приложения
 * (SMY-150). Значит согласие даётся работой, а не нажатием: «нажимая кнопку,
 * вы соглашаетесь» описывает событие, которого у гостя не происходит вовсе, и
 * доказывать им было бы нечего.
 *
 * Ссылки на документы подставляет платформа: в вебе это переходы, в приложении
 * — открытие браузера. Текст один, разметка разная — поэтому здесь строка, а
 * не готовая вёрстка.
 *
 * ПОЛУЧАТЕЛИ НАЗВАНЫ В САМОЙ СТРОКЕ — с 15.09.2026, решением владельца по
 * пункту 5.1.2(i) правил App Store (docs/app-store.md, пункт 1). Правило
 * требует ясно сказать, куда уходят персональные данные, отдельно называя
 * ИИ-поставщиков, и получить явное разрешение до передачи. Выбрано назвать
 * получателей здесь, а не заводить отдельный шит: раскрытие есть, а разрешение
 * по-прежнему даётся продолжением работы — остаточный риск отказа на ревью
 * записан там же. Список получателей — п. 6.2 политики: появится ещё один
 * поставщик содержимого задач — править строку вместе с политикой.
 */
export const CONSENT_NOTICE =
  'Продолжая, вы принимаете оферту и политику обработки данных и соглашаетесь, ' +
  'что текст задач и файлы передаются на обработку ИИ-сервисам Яндекса и Cloud.ru.'

/**
 * Как называются документы, на которые ведут ссылки.
 *
 * Отдельно от самой фразы: подписи к ссылкам нужны и там, где фразы нет, —
 * в футере лендинга и в профиле. Одни и те же слова в трёх местах, иначе
 * «Политика обработки данных» и «Политика конфиденциальности» окажутся, с
 * точки зрения человека, разными документами.
 */
export const LEGAL_DOC_TITLES = {
  offer: 'Оферта',
  privacy: 'Политика обработки данных',
  aup: 'Правила использования',
} as const

export type LegalDoc = keyof typeof LEGAL_DOC_TITLES
